import IconStar from '@/assets/icons/star.svg';
import IconPremium from '@/assets/icons/premium.svg';
import noUserImage from '@/assets/noprofile.png';
import trim from 'lodash/trim';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapChannelState } = createNamespacedHelpers('Channel');

export default {
  name: 'ChannelItem',
  mixins: [],
  components: { IconStar, IconPremium },
  props: {
    channelUrl: String,
    nickname: String,
    payload: Object,
    totalRewards: Number,
    avatarUrl: String,
    isPremium: Boolean
  },

  computed: {
    ...mapChannelState({
      isUnread: function(state) {
        return !!state.unreadChannels[this.channelUrl];
      }
    }),

    profilePicture: function() {
      const { avatarUrl: url } = this;
      if (url && trim(url) !== '') {
        return url;
      }

      return noUserImage;
    }
  },

  methods: {
    replaceWithNoPic(e) {
      e.target.src = noUserImage;
    }
  }
};
